import { CreateContactMutation, FeatureDomain } from '@akin-home/amplify';
import { showSuccessToast } from '@akin-home/toast/native';
import { sendBackgroundMessage } from '../../chat/functions';
import { intent_labels } from '../../chat/intent_labels';
import { postCreateRecordLogEvent } from '../../logging/functions/postCreateRecordLogEvent';
import { getCurrentUserID } from '../../users/functions';

type Params = CreateContactMutation;

export const afterCreateContact = ({ createContact }: Params) => {
  sendBackgroundMessage(intent_labels.create_contact, {
    context: {
      contact: {
        id: createContact?.id,
        name: createContact?.name,
      },
    },
  });

  showSuccessToast({ text1: 'Contact Saved!' });

  postCreateRecordLogEvent({
    user_id: getCurrentUserID() as string,
    feature_domain: FeatureDomain.CONTACTS,
    data: {
      id: createContact?.id,
      model: 'Contact',
    },
  });
};
